export default {"src":"/_next/static/media/seamless-process.92a1e118.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};